export enum SurveyView {
  MY_SURVEYS = 1,
  NEW = 2,
  DETAIL = 3,
  DETAIL_MEMBERS = 4,
  DETAIL_QUESTIONS = 5,
  DETAIL_RESULTS = 6,
  DETAIL_SETTINGS = 7,
  ARCHIVE = 8,
  ARCHIVE_DETAIL = 9,
}
